import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/myBoard/'
export const SET_IS_CARD_IN_MYBOARD = NAMESPACE + 'SET_IS_CARD_IN_MYBOARD'
export const SET_MYBOARD = NAMESPACE + 'SET_MYBOARD'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'

const defaultCardState = {
  isCardInMyBoard: false,
  myBoard: null,
  isLoading: false,
  isLoaded: false
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: {
          ...defaultCardState,
        }
      }
    case SET_IS_CARD_IN_MYBOARD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isCardInMyBoard: action.payload.isCardInMyBoard,
          myBoard: action.payload.isCardInMyBoard ? state[action.payload.cardId].myBoard : null
        }
      } : state
    case SET_MYBOARD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          myBoard: action.payload.myBoard
        }
      } : state
    case SET_LOAD_STATUS:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: {
          ...state[action.payload.cardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    default: return state
  }
}

export function setIsCardInMyBoard ({ cardId, isCardInMyBoard }) {
  return {
    type: SET_IS_CARD_IN_MYBOARD,
    payload: {
      cardId,
      isCardInMyBoard
    }
  }
}

export function setMyBoard ({ cardId, myBoard }) {
  return {
    type: SET_MYBOARD,
    payload: {
      cardId,
      myBoard
    }
  }
}

export function setLoadStatus ({ cardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      cardId,
      isLoading,
      isLoaded
    }
  }
}
